import { useState } from 'react';

export default function DrawRoster({ data, names, locked, act, loadError, onReload }) {
  const [outgoing, setOutgoing] = useState('');
  const [incoming, setIncoming] = useState('');
  const pool = data.draw.pool;
  const reserves = data.tour.drawRoster?.reserves || [];
  const candidates = names.filter((name) => !pool.includes(name));
  const replace = async (event) => {
    event.preventDefault();
    if (await act('replace', { outgoing, incoming })) { setOutgoing(''); setIncoming(''); }
  };
  return <section className="draw-admin-section draw-roster">
    <details><summary>Основной состав <b>{pool.length} команд</b></summary>
      <ol className="draw-roster-main">{pool.map((name) => <li key={name}>{name}</li>)}</ol>
    </details>
    <details open>
      <summary>Резерв <b>{reserves.length} / 4</b></summary>
      <p className="draw-note">Выберите до четырёх команд из прежнего списка. Резерв сохраняется сразу и не участвует в колесе до замены.</p>
      {loadError && <p role="alert" className="draw-error">{loadError}</p>}
      <div className="draw-participants" aria-label="Выбор резерва">{candidates.map((name) => <label key={name}>
        <input type="checkbox" checked={reserves.includes(name)} disabled={locked || (!reserves.includes(name) && reserves.length >= 4)}
          onChange={(event) => act('reserves', { teams: event.target.checked ? [...reserves, name] : reserves.filter((n) => n !== name) })} />
        <span>{name}</span>
      </label>)}</div>
      {!candidates.length && <p className="draw-note">Свободных команд пока нет.</p>}
      <button disabled={locked} onClick={onReload}>Обновить список команд</button>
      {reserves.length > 0 && <form className="draw-manual draw-roster-replace" onSubmit={replace}>
        <h3>Замена участника</h3>
        <label>Кого заменить<select required aria-label="Кого заменить" value={pool.includes(outgoing) ? outgoing : ''} onChange={(e) => setOutgoing(e.target.value)}><option value="">Участник основного состава</option>{pool.map((name) => <option key={name}>{name}</option>)}</select></label>
        <label>Кого взять из резерва<select required aria-label="Кого взять из резерва" value={reserves.includes(incoming) ? incoming : ''} onChange={(e) => setIncoming(e.target.value)}><option value="">Резервная команда</option>{reserves.map((name) => <option key={name}>{name}</option>)}</select></label>
        <p className="draw-note">Новая команда займёт то же место в пуле или группе. Выбывшая перейдёт в резерв. Расстановка остальных сохранится.</p>
        <button disabled={locked || !pool.includes(outgoing) || !reserves.includes(incoming)}>Заменить участника</button>
      </form>}
    </details>
  </section>;
}
